import React from 'react';
import PropTypes from 'prop-types';

import { Avatar as MUIAvatar } from '@mui/material';

export const Avatar = props => <MUIAvatar {...props} />;

Avatar.propTypes = {
  alt: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  classes: PropTypes.object,
  imgProps: PropTypes.object,
  sizes: PropTypes.string,
  src: PropTypes.string,
  srcSet: PropTypes.string,
  style: PropTypes.object,
  variant: PropTypes.oneOf(['circle', 'circular', 'rounded', 'square'])
};

export default Avatar;
